export const throwError = (message: string) => {
  throw Error(`[Senn-node-feature-flags-frontend]: ${message}`)
}

export const showWarning = (message: string) => {
  console.warn(`[Senn-node-feature-flags-frontend]: ${message}`)
}
